type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
};

export function WifiIcon({ width = 12, height = 12, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            className={className}
            style={style}
        >
            <path
                d="M2.49996 6.27514C3.48824 5.45197 4.73376 5.0012 6.01996 5.0012C7.30616 5.0012 8.55168 5.45197 9.53996 6.27514M0.709961 4.50014C2.17117 3.21212 4.05211 2.50146 5.99996 2.50146C7.94781 2.50146 9.82875 3.21212 11.29 4.50014M4.26496 8.05514C4.77256 7.69451 5.3798 7.50077 6.00246 7.50077C6.62512 7.50077 7.23236 7.69451 7.73996 8.05514M5.99996 10.0001H6.00496"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default WifiIcon;
